import React, { useEffect, useState, lazy, Suspense } from "react";
import CacheBuster from 'react-cache-buster';
import appversion from '../package.json';
import { CookieSetting } from "cookiesetting-component";

const Footer = lazy(() => import("./Components/FooterComponent/index.js"));
const Navbar = lazy(() => import("./Components/Navbar"));
const Convo = lazy(() => import("./Components/Convo"));
const Information = lazy(() => import("./Components/Information"));
const FHA = lazy(() => import("./Components/FHA"));
const Declaimer = lazy(() => import("./Components/Declaimer"));
const appVersion = appversion.version;
function App() {
  return (
    <div className="App">
      <CacheBuster
      currentVersion={appVersion}
      isEnabled={true} //If false, the library is disabled.
      isVerboseMode={false} //If true, the library writes verbose logs to console.
        >
          <CookieSetting 
        privacyPolicyLink={process.env.REACT_APP_PRIVACY_POLICY_LINK} 
        configUrl={process.env.REACT_APP_COOKIE_SETTING_JSON}
        analytics={process.env.REACT_APP_ANALYTICS_PATH}
      />
   
      <Suspense fallback={<div />}>
        <Navbar />
      </Suspense>
      <Suspense fallback={<div />}>
        <Information />
      </Suspense>
      <Suspense fallback={<div />}>
        <Convo />
      </Suspense>
      <Suspense fallback={<div />}>
        <FHA />
      </Suspense>
      <Suspense fallback={<div />}>
        <Declaimer />
      </Suspense>
      <Suspense fallback={<div />}>
        <Footer />
      </Suspense>
      </CacheBuster>
    </div>
  );
}

export default App;
